import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from '@cmps/ng-select';
import { CmpsIconModule, CmpsTooltipModule } from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../common/common.module';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';
import { CmpsLazyRouterModule } from '../route.module';

import { GridComponent } from './experimental.grid';
import { FormTdcfComponent } from './form.tdcf.component';
import { ManagerReportTdcfComponent } from './manager-report.tdcf.component';
import { PrintPreviewTdcfComponent } from './print-preview.tdcf.component';
import { SearchTdcfComponent } from './search.tdcf.component';
import { TableManagerReportTdcfComponent } from './table-manager-report.tdcf.component';
import { TableTdcfComponent } from './table.tdcf.component';
import { TranslationIdMap } from './tdcf-form.i18n';
import { TdCfFormRoutes } from './tdcf-form.route';
import { TdcfComponent } from './tdcf.component';
import { TdcfService } from './tdcf.service';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        SelectModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsCommonModule,
        CmpsLazyRouterModule.forChild(TdCfFormRoutes),
        CmpsIconModule,
        CmpsTooltipModule,
    ],
    declarations: [
        TdcfComponent,
        SearchTdcfComponent,
        TableTdcfComponent,
        FormTdcfComponent,
        ManagerReportTdcfComponent,
        TableManagerReportTdcfComponent,
        PrintPreviewTdcfComponent,
        GridComponent,
    ],
})
export class CmpsTdCfFormModule {
    static forRoot(): ModuleWithProviders<CmpsTdCfFormModule> {
        return {
            ngModule: CmpsTdCfFormModule,
            providers: [TdcfService],
        };
    }
}
